/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createOrganization } from '../fn/admin-organizations-api/create-organization';
import { CreateOrganization$Params } from '../fn/admin-organizations-api/create-organization';
import { createOrganizationContact } from '../fn/admin-organizations-api/create-organization-contact';
import { CreateOrganizationContact$Params } from '../fn/admin-organizations-api/create-organization-contact';
import { createPermissionGroup } from '../fn/admin-organizations-api/create-permission-group';
import { CreatePermissionGroup$Params } from '../fn/admin-organizations-api/create-permission-group';
import { deleteContact } from '../fn/admin-organizations-api/delete-contact';
import { DeleteContact$Params } from '../fn/admin-organizations-api/delete-contact';
import { deleteOrganization } from '../fn/admin-organizations-api/delete-organization';
import { DeleteOrganization$Params } from '../fn/admin-organizations-api/delete-organization';
import { deletePermissionGroup } from '../fn/admin-organizations-api/delete-permission-group';
import { DeletePermissionGroup$Params } from '../fn/admin-organizations-api/delete-permission-group';
import { getAllOrganizations } from '../fn/admin-organizations-api/get-all-organizations';
import { GetAllOrganizations$Params } from '../fn/admin-organizations-api/get-all-organizations';
import { getAllOrganizationsRef } from '../fn/admin-organizations-api/get-all-organizations-ref';
import { GetAllOrganizationsRef$Params } from '../fn/admin-organizations-api/get-all-organizations-ref';
import { getOrganization } from '../fn/admin-organizations-api/get-organization';
import { GetOrganization$Params } from '../fn/admin-organizations-api/get-organization';
import { getOrganizationAdmins } from '../fn/admin-organizations-api/get-organization-admins';
import { GetOrganizationAdmins$Params } from '../fn/admin-organizations-api/get-organization-admins';
import { getOrganizationContacts } from '../fn/admin-organizations-api/get-organization-contacts';
import { GetOrganizationContacts$Params } from '../fn/admin-organizations-api/get-organization-contacts';
import { getOrganizationContactTypes } from '../fn/admin-organizations-api/get-organization-contact-types';
import { GetOrganizationContactTypes$Params } from '../fn/admin-organizations-api/get-organization-contact-types';
import { getOrganizationPermissionGroups } from '../fn/admin-organizations-api/get-organization-permission-groups';
import { GetOrganizationPermissionGroups$Params } from '../fn/admin-organizations-api/get-organization-permission-groups';
import { getOrganizationRelations1 } from '../fn/admin-organizations-api/get-organization-relations-1';
import { GetOrganizationRelations1$Params } from '../fn/admin-organizations-api/get-organization-relations-1';
import { getOrganizationTowerGroups } from '../fn/admin-organizations-api/get-organization-tower-groups';
import { GetOrganizationTowerGroups$Params } from '../fn/admin-organizations-api/get-organization-tower-groups';
import { getOrganizationTowers } from '../fn/admin-organizations-api/get-organization-towers';
import { GetOrganizationTowers$Params } from '../fn/admin-organizations-api/get-organization-towers';
import { getOrganizationUsers } from '../fn/admin-organizations-api/get-organization-users';
import { GetOrganizationUsers$Params } from '../fn/admin-organizations-api/get-organization-users';
import { getPartnerOrganizations } from '../fn/admin-organizations-api/get-partner-organizations';
import { GetPartnerOrganizations$Params } from '../fn/admin-organizations-api/get-partner-organizations';
import { OrganizationContactDto } from '../models/organization-contact-dto';
import { OrganizationDto } from '../models/organization-dto';
import { OrganizationRefDto } from '../models/organization-ref-dto';
import { OrganizationRelationsDto } from '../models/organization-relations-dto';
import { PageDtoOrganizationOrganizationDto } from '../models/page-dto-organization-organization-dto';
import { PermissionGroupDto } from '../models/permission-group-dto';
import { SimpleList } from '../models/simple-list';
import { TowerDto } from '../models/tower-dto';
import { TowerGroupCardDto } from '../models/tower-group-card-dto';
import { updateContact } from '../fn/admin-organizations-api/update-contact';
import { UpdateContact$Params } from '../fn/admin-organizations-api/update-contact';
import { updateOrganization } from '../fn/admin-organizations-api/update-organization';
import { UpdateOrganization$Params } from '../fn/admin-organizations-api/update-organization';
import { updateOrganizationPermissions } from '../fn/admin-organizations-api/update-organization-permissions';
import { UpdateOrganizationPermissions$Params } from '../fn/admin-organizations-api/update-organization-permissions';
import { updatePermissionGroup } from '../fn/admin-organizations-api/update-permission-group';
import { UpdatePermissionGroup$Params } from '../fn/admin-organizations-api/update-permission-group';
import { UserCardDto } from '../models/user-card-dto';

@Injectable({ providedIn: 'root' })
export class AdminOrganizationsApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getOrganization()` */
  static readonly GetOrganizationPath = '/api/admin/organizations/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOrganization()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOrganization$Response(params: GetOrganization$Params, context?: HttpContext): Observable<StrictHttpResponse<OrganizationDto>> {
    return getOrganization(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOrganization$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOrganization(params: GetOrganization$Params, context?: HttpContext): Observable<OrganizationDto> {
    return this.getOrganization$Response(params, context).pipe(
      map((r: StrictHttpResponse<OrganizationDto>): OrganizationDto => r.body)
    );
  }

  /** Path part for operation `updateOrganization()` */
  static readonly UpdateOrganizationPath = '/api/admin/organizations/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateOrganization()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateOrganization$Response(params: UpdateOrganization$Params, context?: HttpContext): Observable<StrictHttpResponse<OrganizationDto>> {
    return updateOrganization(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateOrganization$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateOrganization(params: UpdateOrganization$Params, context?: HttpContext): Observable<OrganizationDto> {
    return this.updateOrganization$Response(params, context).pipe(
      map((r: StrictHttpResponse<OrganizationDto>): OrganizationDto => r.body)
    );
  }

  /** Path part for operation `deleteOrganization()` */
  static readonly DeleteOrganizationPath = '/api/admin/organizations/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteOrganization()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteOrganization$Response(params: DeleteOrganization$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteOrganization(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteOrganization$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteOrganization(params: DeleteOrganization$Params, context?: HttpContext): Observable<void> {
    return this.deleteOrganization$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateOrganizationPermissions()` */
  static readonly UpdateOrganizationPermissionsPath = '/api/admin/organizations/{id}/permissions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateOrganizationPermissions()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateOrganizationPermissions$Response(params: UpdateOrganizationPermissions$Params, context?: HttpContext): Observable<StrictHttpResponse<OrganizationDto>> {
    return updateOrganizationPermissions(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateOrganizationPermissions$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateOrganizationPermissions(params: UpdateOrganizationPermissions$Params, context?: HttpContext): Observable<OrganizationDto> {
    return this.updateOrganizationPermissions$Response(params, context).pipe(
      map((r: StrictHttpResponse<OrganizationDto>): OrganizationDto => r.body)
    );
  }

  /** Path part for operation `updatePermissionGroup()` */
  static readonly UpdatePermissionGroupPath = '/api/admin/organizations/{id}/permissionGroups/{permissionGroupId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updatePermissionGroup()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updatePermissionGroup$Response(params: UpdatePermissionGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<PermissionGroupDto>> {
    return updatePermissionGroup(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updatePermissionGroup$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updatePermissionGroup(params: UpdatePermissionGroup$Params, context?: HttpContext): Observable<PermissionGroupDto> {
    return this.updatePermissionGroup$Response(params, context).pipe(
      map((r: StrictHttpResponse<PermissionGroupDto>): PermissionGroupDto => r.body)
    );
  }

  /** Path part for operation `updateContact()` */
  static readonly UpdateContactPath = '/api/admin/organizations/{id}/contacts/{contactId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateContact()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateContact$Response(params: UpdateContact$Params, context?: HttpContext): Observable<StrictHttpResponse<OrganizationContactDto>> {
    return updateContact(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateContact$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateContact(params: UpdateContact$Params, context?: HttpContext): Observable<OrganizationContactDto> {
    return this.updateContact$Response(params, context).pipe(
      map((r: StrictHttpResponse<OrganizationContactDto>): OrganizationContactDto => r.body)
    );
  }

  /** Path part for operation `deleteContact()` */
  static readonly DeleteContactPath = '/api/admin/organizations/{id}/contacts/{contactId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteContact()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteContact$Response(params: DeleteContact$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteContact(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteContact$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteContact(params: DeleteContact$Params, context?: HttpContext): Observable<void> {
    return this.deleteContact$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getAllOrganizations()` */
  static readonly GetAllOrganizationsPath = '/api/admin/organizations';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllOrganizations()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllOrganizations$Response(params?: GetAllOrganizations$Params, context?: HttpContext): Observable<StrictHttpResponse<PageDtoOrganizationOrganizationDto>> {
    return getAllOrganizations(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllOrganizations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllOrganizations(params?: GetAllOrganizations$Params, context?: HttpContext): Observable<PageDtoOrganizationOrganizationDto> {
    return this.getAllOrganizations$Response(params, context).pipe(
      map((r: StrictHttpResponse<PageDtoOrganizationOrganizationDto>): PageDtoOrganizationOrganizationDto => r.body)
    );
  }

  /** Path part for operation `createOrganization()` */
  static readonly CreateOrganizationPath = '/api/admin/organizations';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createOrganization()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createOrganization$Response(params: CreateOrganization$Params, context?: HttpContext): Observable<StrictHttpResponse<OrganizationDto>> {
    return createOrganization(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createOrganization$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createOrganization(params: CreateOrganization$Params, context?: HttpContext): Observable<OrganizationDto> {
    return this.createOrganization$Response(params, context).pipe(
      map((r: StrictHttpResponse<OrganizationDto>): OrganizationDto => r.body)
    );
  }

  /** Path part for operation `getOrganizationPermissionGroups()` */
  static readonly GetOrganizationPermissionGroupsPath = '/api/admin/organizations/{id}/permissionGroups';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOrganizationPermissionGroups()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOrganizationPermissionGroups$Response(params: GetOrganizationPermissionGroups$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PermissionGroupDto>>> {
    return getOrganizationPermissionGroups(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOrganizationPermissionGroups$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOrganizationPermissionGroups(params: GetOrganizationPermissionGroups$Params, context?: HttpContext): Observable<Array<PermissionGroupDto>> {
    return this.getOrganizationPermissionGroups$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PermissionGroupDto>>): Array<PermissionGroupDto> => r.body)
    );
  }

  /** Path part for operation `createPermissionGroup()` */
  static readonly CreatePermissionGroupPath = '/api/admin/organizations/{id}/permissionGroups';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createPermissionGroup()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createPermissionGroup$Response(params: CreatePermissionGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<PermissionGroupDto>> {
    return createPermissionGroup(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createPermissionGroup$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createPermissionGroup(params: CreatePermissionGroup$Params, context?: HttpContext): Observable<PermissionGroupDto> {
    return this.createPermissionGroup$Response(params, context).pipe(
      map((r: StrictHttpResponse<PermissionGroupDto>): PermissionGroupDto => r.body)
    );
  }

  /** Path part for operation `getOrganizationContacts()` */
  static readonly GetOrganizationContactsPath = '/api/admin/organizations/{id}/contacts';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOrganizationContacts()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOrganizationContacts$Response(params: GetOrganizationContacts$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OrganizationContactDto>>> {
    return getOrganizationContacts(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOrganizationContacts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOrganizationContacts(params: GetOrganizationContacts$Params, context?: HttpContext): Observable<Array<OrganizationContactDto>> {
    return this.getOrganizationContacts$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<OrganizationContactDto>>): Array<OrganizationContactDto> => r.body)
    );
  }

  /** Path part for operation `createOrganizationContact()` */
  static readonly CreateOrganizationContactPath = '/api/admin/organizations/{id}/contacts';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createOrganizationContact()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createOrganizationContact$Response(params: CreateOrganizationContact$Params, context?: HttpContext): Observable<StrictHttpResponse<OrganizationContactDto>> {
    return createOrganizationContact(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createOrganizationContact$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createOrganizationContact(params: CreateOrganizationContact$Params, context?: HttpContext): Observable<OrganizationContactDto> {
    return this.createOrganizationContact$Response(params, context).pipe(
      map((r: StrictHttpResponse<OrganizationContactDto>): OrganizationContactDto => r.body)
    );
  }

  /** Path part for operation `getOrganizationUsers()` */
  static readonly GetOrganizationUsersPath = '/api/admin/organizations/{id}/users';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOrganizationUsers()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOrganizationUsers$Response(params: GetOrganizationUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserCardDto>>> {
    return getOrganizationUsers(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOrganizationUsers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOrganizationUsers(params: GetOrganizationUsers$Params, context?: HttpContext): Observable<Array<UserCardDto>> {
    return this.getOrganizationUsers$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<UserCardDto>>): Array<UserCardDto> => r.body)
    );
  }

  /** Path part for operation `getOrganizationTowers()` */
  static readonly GetOrganizationTowersPath = '/api/admin/organizations/{id}/towers';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOrganizationTowers()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOrganizationTowers$Response(params: GetOrganizationTowers$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TowerDto>>> {
    return getOrganizationTowers(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOrganizationTowers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOrganizationTowers(params: GetOrganizationTowers$Params, context?: HttpContext): Observable<Array<TowerDto>> {
    return this.getOrganizationTowers$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<TowerDto>>): Array<TowerDto> => r.body)
    );
  }

  /** Path part for operation `getOrganizationTowerGroups()` */
  static readonly GetOrganizationTowerGroupsPath = '/api/admin/organizations/{id}/towerGroups';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOrganizationTowerGroups()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOrganizationTowerGroups$Response(params: GetOrganizationTowerGroups$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TowerGroupCardDto>>> {
    return getOrganizationTowerGroups(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOrganizationTowerGroups$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOrganizationTowerGroups(params: GetOrganizationTowerGroups$Params, context?: HttpContext): Observable<Array<TowerGroupCardDto>> {
    return this.getOrganizationTowerGroups$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<TowerGroupCardDto>>): Array<TowerGroupCardDto> => r.body)
    );
  }

  /** Path part for operation `getOrganizationRelations1()` */
  static readonly GetOrganizationRelations1Path = '/api/admin/organizations/{id}/relations';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOrganizationRelations1()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOrganizationRelations1$Response(params: GetOrganizationRelations1$Params, context?: HttpContext): Observable<StrictHttpResponse<OrganizationRelationsDto>> {
    return getOrganizationRelations1(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOrganizationRelations1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOrganizationRelations1(params: GetOrganizationRelations1$Params, context?: HttpContext): Observable<OrganizationRelationsDto> {
    return this.getOrganizationRelations1$Response(params, context).pipe(
      map((r: StrictHttpResponse<OrganizationRelationsDto>): OrganizationRelationsDto => r.body)
    );
  }

  /** Path part for operation `getOrganizationAdmins()` */
  static readonly GetOrganizationAdminsPath = '/api/admin/organizations/{id}/admins';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOrganizationAdmins()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOrganizationAdmins$Response(params: GetOrganizationAdmins$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserCardDto>>> {
    return getOrganizationAdmins(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOrganizationAdmins$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOrganizationAdmins(params: GetOrganizationAdmins$Params, context?: HttpContext): Observable<Array<UserCardDto>> {
    return this.getOrganizationAdmins$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<UserCardDto>>): Array<UserCardDto> => r.body)
    );
  }

  /** Path part for operation `getAllOrganizationsRef()` */
  static readonly GetAllOrganizationsRefPath = '/api/admin/organizations/ref';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllOrganizationsRef()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllOrganizationsRef$Response(params?: GetAllOrganizationsRef$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OrganizationRefDto>>> {
    return getAllOrganizationsRef(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllOrganizationsRef$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllOrganizationsRef(params?: GetAllOrganizationsRef$Params, context?: HttpContext): Observable<Array<OrganizationRefDto>> {
    return this.getAllOrganizationsRef$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<OrganizationRefDto>>): Array<OrganizationRefDto> => r.body)
    );
  }

  /** Path part for operation `getPartnerOrganizations()` */
  static readonly GetPartnerOrganizationsPath = '/api/admin/organizations/partners';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPartnerOrganizations()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPartnerOrganizations$Response(params?: GetPartnerOrganizations$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OrganizationDto>>> {
    return getPartnerOrganizations(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPartnerOrganizations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPartnerOrganizations(params?: GetPartnerOrganizations$Params, context?: HttpContext): Observable<Array<OrganizationDto>> {
    return this.getPartnerOrganizations$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<OrganizationDto>>): Array<OrganizationDto> => r.body)
    );
  }

  /** Path part for operation `getOrganizationContactTypes()` */
  static readonly GetOrganizationContactTypesPath = '/api/admin/organizations/contacttypes/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOrganizationContactTypes()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOrganizationContactTypes$Response(params?: GetOrganizationContactTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<SimpleList>> {
    return getOrganizationContactTypes(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOrganizationContactTypes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOrganizationContactTypes(params?: GetOrganizationContactTypes$Params, context?: HttpContext): Observable<SimpleList> {
    return this.getOrganizationContactTypes$Response(params, context).pipe(
      map((r: StrictHttpResponse<SimpleList>): SimpleList => r.body)
    );
  }

  /** Path part for operation `deletePermissionGroup()` */
  static readonly DeletePermissionGroupPath = '/api/admin/organizations/{id}/permissionGroup/{permissionGroupId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deletePermissionGroup()` instead.
   *
   * This method doesn't expect any request body.
   */
  deletePermissionGroup$Response(params: DeletePermissionGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deletePermissionGroup(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deletePermissionGroup$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deletePermissionGroup(params: DeletePermissionGroup$Params, context?: HttpContext): Observable<void> {
    return this.deletePermissionGroup$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
